import type { TokenData } from '@autobid/nuxt-auth/src/utils/decodeJwt'
import type { PermissionMap } from '@autobid/strapi-integration/typescript/cerber/permissions'
import { useToken } from '@autobid/nuxt-auth/src/composables/useToken'

interface Props {
  permissionName: string
  appId: number
  tokenData: TokenData | null
  permissionsMap: PermissionMap | null | undefined
}

export function checkUserPermission({ permissionName, appId, permissionsMap, tokenData }: Props) {
  if (!permissionsMap || !tokenData)
    return false

  const indexOfPermission
      = permissionsMap[appId]?.indexOf(permissionName)

  if (typeof indexOfPermission === 'undefined')
    return false

  return tokenData.access.apps[appId][indexOfPermission] === '1'
}

export function useCheckUserPermission() {
  const { tokenData, permissionsMap } = useToken()
  const APP_ID = useRuntimeConfig().public.APP_ID

  /**
   * Check if user has the required permission
   * @param permissionName - name of the permission from the profile
   * @param _appId - if not provided, current app id will be used
   */
  const _checkUserPermission = (permissionName: string, _appId?: number) => {
    return checkUserPermission({
      appId: _appId ?? APP_ID,
      permissionName,
      permissionsMap: permissionsMap.value,
      tokenData: tokenData.value,
    })
  }

  return { checkUserPermission: _checkUserPermission }
}
